import { ButtonLinkStylesSettings } from './ButtonStyles';

const ButtonLink = ({ text, underline, disabled, onClick, className = '' }) => {
    const style = underline ? ButtonLinkStylesSettings.Underline : ButtonLinkStylesSettings.Primary;

    const calcButtonStyle = () => {
        let styleStr = `text-${style.color} hover:text-${style.colorHover} ${style.border} ${style.borderWidth} hover:border-${style.colorHover}`;
        if (disabled) {
            styleStr = `text-${style.colorDisabled}`;
        }

        return styleStr;
    };

    return (
        <div
            onClick={disabled ? () => {} : onClick}
            className={`${className} font-sf select-none gap-2 ${calcButtonStyle()} ${
                disabled ? 'cursor-not-allowed' : 'cursor-pointer'
            } transition ease-out duration-300 flex items-center justify-center font-medium`}>
            {text}
        </div>
    );
};

export default ButtonLink;
